module.exports = __webpack_public_path__ + "images/backgrounds/purple-blur.3a02eab932195316109b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/purple-blur.png
// module id = Ytgn
// module chunks = 24